import { render, staticRenderFns } from "./PromocodesList.vue?vue&type=template&id=c0ca4bfc"
import script from "./PromocodesList.vue?vue&type=script&lang=js"
export * from "./PromocodesList.vue?vue&type=script&lang=js"
import style0 from "./PromocodesList.vue?vue&type=style&index=0&id=c0ca4bfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports